module.exports = __webpack_public_path__ + "static/media/christmas-songs-on-bass-guitar-album-cover.7904874b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/music/christmas-songs-on-bass-guitar/christmas-songs-on-bass-guitar-album-cover.jpg
// module id = 22
// module chunks = 0